import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import { SharedZoneBlocks, SharedZoneBeautyContent } from 'store/SharedZone/blocks/selectors';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

function SignBlock({ author, date, isMobile }) {
  return (
    <div className={cx('component', isMobile && 'mobile')}>
      {author && <span className={cx('sign')}>{author}</span>}
      {date && (
        <>
          {' '}
          |<span className={cx('sign')}>{date}</span>
        </>
      )}
    </div>
  );
}

SignBlock.propTypes = {
  author: PropTypes.string,
  date: PropTypes.string,
  isMobile: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  author: SharedZoneBeautyContent.getAuthor(state),
  date: SharedZoneBeautyContent.getDate(state),
});

export default SharedZoneBlocks.connect(mapStateToProps)(SignBlock);
